import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homeone-scientist',
    templateUrl: './homeone-scientist.component.html',
    styleUrls: ['./homeone-scientist.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeoneScientistComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Team Members",
            title: 'Our Passionate Team Members',
            paragraphText: 'Meet our dedicated and passionate team who drive innovation and excellence in every project.'
        }
    ]
    singleScientistBox: scientistBoxContent[] = [
        {
            img: 'assets/img/scientist/founder1-removebg-preview.jpg',
            title: 'Attiq Ur Rehman',
            designation: 'Founder, CEO',
            facebookLink: '#',
            facebookIcon: 'bx bxl-facebook',
            githubLink: 'https://github.com/attiquiitdev',
            githubIcon: 'bx bxl-github',
            linkedinLink: 'https://www.linkedin.com/in/attiq-ur-rehman-005142ab/',
            linkedinIcon: 'bx bxl-linkedin'
        },
        {
            img: 'assets/img/scientist/habibnew-removebg-preview.jpg',
            title: 'Habib Ur Rehman',
            designation: 'Co-Founder, CTO',
            facebookLink: '#',
            facebookIcon: 'bx bxl-facebook',
            githubLink: 'https://github.com/Habibhere',
            githubIcon: 'bx bxl-github',
            linkedinLink: 'https://www.linkedin.com/in/habib-ur-rehman-34a197118/',
            linkedinIcon: 'bx bxl-linkedin'
         },
         {
            img: 'assets/img/scientist/rashid-profile-pic.jpg',
            title: 'Rashid Hussain',
            designation: 'Head of Engineering',
            facebookLink: '#',
            facebookIcon: 'bx bxl-facebook',
            githubLink: 'https://github.com/rashidhussainkhokhar',
            githubIcon: 'bx bxl-github',
            linkedinLink: 'https://www.linkedin.com/in/rashid-hussain-147107125/',
            linkedinIcon: 'bx bxl-linkedin'
         }
        // {
        //     img: 'assets/img/scientist/img3.png',
        //     title: 'Carla Gentry',
        //     designation: 'Analytical Solutions',
        //     facebookLink: '#',
        //     facebookIcon: 'bx bxl-facebook',
        //     twitterLink: '#',
        //     twitterIcon: 'bx bxl-twitter',
        //     instagramLink: '#',
        //     instagramIcon: 'bx bxl-instagram',
        //     linkedinLink: '#',
        //     linkedinIcon: 'bx bxl-linkedin'
        // },
        // {
        //     img: 'assets/img/scientist/img4.png',
        //     title: 'Marie Curie',
        //     designation: 'Data Scientist',
        //     facebookLink: '#',
        //     facebookIcon: 'bx bxl-facebook',
        //     twitterLink: '#',
        //     twitterIcon: 'bx bxl-twitter',
        //     instagramLink: '#',
        //     instagramIcon: 'bx bxl-instagram',
        //     linkedinLink: '#',
        //     linkedinIcon: 'bx bxl-linkedin'
        // }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class scientistBoxContent {
    img: string;
    title: string;
    designation: string;
    facebookLink: string;
    facebookIcon: string;
    //twitterLink: string;
    //twitterIcon: string;
    //instagramLink: string;
    //instagramIcon: string;
    linkedinLink: string;
    linkedinIcon: string;
    githubLink: string;
    githubIcon: string;
}